import React, { Fragment } from "react"
import EstateStatus from "./estateStatus"
import EstateTitle from "./estateTitle"
import { HeaderContainer } from "./janowotwo/janowoTwoStyle"
import { Col, Container, Row } from "react-bootstrap"
import { injectIntl } from "gatsby-plugin-intl"
import { MobileButton } from "@/components/shared/button/button"
import { Link as Scroller } from "react-scroll"
const EstateHeader = ({
  title,
  place,
  noButton,
  inProgress,
  done,
  trailer,
  premiere,
  completed,
  price,
}) => {
  const noPadding = { padding: 0 }

  return (
    <Fragment>
      <HeaderContainer style={{ marginBottom: "10px" }}>
        <Container style={{ margin: "auto" }}>
          <Row className="align-items-center">
            <Col
              className="content-wrapper"
              style={noPadding}
              xs="12"
              sm="12"
              md="6"
              lg="8"
            >
              <Container fluid style={noPadding}>
                <EstateTitle mainTitle={title} />

                <Row style={noPadding}>
                  <Col xs={"auto"} style={{ padding: "0 1em 0 0" }}>
                    <EstateStatus dark>{place}</EstateStatus>
                  </Col>
                  <Col xs={"auto"} style={{ padding: "0 1em 0 0" }}>
                    <EstateStatus
                      inProgress={inProgress}
                      done={done}
                      trailer={trailer}
                      premiere={premiere}
                      completed={completed}
                    />
                  </Col>
                  {price && (
                    <Col style={{ padding: "0 1em 0 0" }}>
                      <EstateStatus accent>
                        Promocja: Ceny od {price} <span>zł / m</span>
                        <sup>2</sup>
                      </EstateStatus>
                    </Col>
                  )}
                </Row>
              </Container>
            </Col>

            {!noButton && (
              <Col xs="12" sm="12" md="6" lg="4" style={noPadding}>
                <Scroller
                  to="flats"
                  spy={true}
                  smooth={true}
                  offset={-50}
                  duration={500}
                >
                  <MobileButton
                    handleAction={() => {}}
                    innerText={"Zapytaj o ofertę"}
                    bg={"#94C835"}
                    color={"white"}
                    border={"white"}
                    arrow={false}
                    className={"hover"}
                  />
                </Scroller>
              </Col>
            )}
          </Row>
        </Container>
      </HeaderContainer>
    </Fragment>
  )
}

export default injectIntl(EstateHeader)
